import React, { Component } from 'react';
import Header from '../../Components/Header';
import Question from '../../Components/@bit/Question/index';
import {
  ContainerWindowTitle,
  SubTitulo,
  Linha,
  LinhaRodape,
  DivRodape,
  Container,
  DivDetalhe,
  MenuItem,
} from './styles';
import api from '../../services/api';
import { getFromStorage } from '../../services/auth';
import DirectTituloJanela from '../../Components/@bit/DirectTituloJanela/index';
import { Icon } from 'react-materialize';
import { alerta, tratarErros } from '../../services/funcoes';

export default class UsersMenu extends Component {
  state = {
    loading: false,
    listaUsuarios: [],
    usuarioSelecionado: {},
    listaMenus: [],
    permissoesModificadas: false,
  };

  /*INICIALIZACAO TELA*/
  async componentDidMount() {
    this.setState({ loading: true });
    await this.carregarVariaveisEstado();
    await this.carregarListaUsuarios();
    await this.carregarListaMenus();
    this.setState({ loading: false });
  }

  carregarVariaveisEstado = async (e) => {
    const sessao = getFromStorage();
    this.setState({
      empresaAtiva: sessao.empresaId,
      usuarioAtivo: sessao.codigoUsuario,
      empresaCfId: sessao.empresaCfId,
    });
  };

  carregarListaMenus = async () => {
    try {
      const { empresaAtiva } = this.state;
      const retorno = await api.get('/v1/menus/lista/' + empresaAtiva);
      if (!retorno) {
        this.setState({ listaMenus: [] });
      } else {
        if (retorno.data && retorno.data.sucess) {
          let listaMenus = retorno.data.data;

          listaMenus.forEach((menu) => {
            menu.SELECTED = false;
          });
          this.setState({ listaMenus });
        } else {
          this.setState({ listaMenus: [] });
        }
      }
    } catch (err) {
      // //
      alerta('Erro ao carregar as empresas =>' + err);
    }
  };

  carregarListaUsuarios = async () => {
    try {
      const { empresaAtiva } = this.state;
      let url = `/v1/users/${empresaAtiva}`;

      const retorno = await api.get(url);
      if (!retorno) {
        this.setState({ listaUsuarios: [] });
      } else {
        if (retorno.data && retorno.data.sucess) {
          if (retorno.data.data.length === 0) {
            this.setState({ listaUsuarios: [] });
          } else {
            this.setState({
              listaUsuarios: retorno.data.data,
            });
          }
        } else {
          this.setState({ listaUsuarios: [] });
        }
      }
    } catch (err) {
      alerta('Erro ao carregar a lista de book básico =>' + err);
      this.setState({ loading: false });
    }
  };

  carregarListaMenusPermitidos = async (usuarioId) => {
    try {
      await this.handleLimparMenus();
      const { empresaAtiva } = this.state;
      this.setState({ loading: true });
      let url = `/v1/menus/usuario/${empresaAtiva}/${usuarioId}`;

      const retorno = await api.get(url);
      if (retorno) {
        if (retorno.data && retorno.data.sucess) {
          const { listaMenus } = this.state;
          const menusPermitidos = retorno.data.data;
          let _listaMenus = [];

          listaMenus.forEach(async (menu) => {
            menu.SELECTED = false;
            menusPermitidos.forEach(async (permitido) => {
              if (menu.DME_ID.toString() === permitido.DME_ID.toString()) {
                menu.SELECTED = true;
              }
            });
            _listaMenus.push(menu);
          });

          this.setState({ listaMenus: _listaMenus });
        }
      }
      this.setState({ loading: false });
    } catch (err) {
      tratarErros('Erro ao carregar a lista de book básico =>' + err);
      this.setState({ loading: false });
    }
  };

  encontrarUsuario = (usuarioId) => {
    let { listaUsuarios, usuarioSelecionado } = this.state;
    for (let index = 0; index < listaUsuarios.length; index++) {
      const element = listaUsuarios[index];
      if (element.USR_ID.toString() === usuarioId.toString()) {
        usuarioSelecionado = element; //Object.assign({}, usuarioSelecionado);
      }
    }
    this.setState({ usuarioSelecionado });
  };

  doChangeUsuario = (usuarioId) => {
    this.encontrarUsuario(usuarioId);
    this.carregarListaMenusPermitidos(usuarioId);
    this.setState({ permissoesModificadas: false });
  };

  handleChangeUsuario = (usuarioId) => {
    if (!this.state.permissoesModificadas) {
      this.doChangeUsuario(usuarioId);
    }
  };

  handleLimparMenus = () => {
    let { listaMenus } = this.state;
    listaMenus.forEach((empresa) => {
      empresa.SELECTED = false;
    });
    this.setState({ listaMenus: listaMenus });
  };

  handleCheckEmpresa = (e, empresaSelecionada) => {
    var { listaMenus, usuarioSelecionado } = this.state;
    if (usuarioSelecionado.USR_ID === undefined) {
      e.target.checked = false;
      alerta(
        'Antes de adicionar as empresas é necessário que você selecione um usuário.',
        1
      );
      return;
    }
    listaMenus.forEach((empresa) => {
      if (empresaSelecionada === empresa) {
        empresa.SELECTED = e.target.checked;
      }
    });
    this.setState({
      listaMenus: listaMenus,
    });
  };

  preparaListaSubMenus = (menuId, checked = false) => {
    let { listaMenus } = this.state;

    listaMenus !== undefined &&
      Array.from(listaMenus).forEach((menu) => {
        if (menu.DME_DME_ID === menuId) {
          menu.SELECTED = checked;
        }
        if (menu.DME_ID === menuId) {
          menu.SELECTED = checked;
        }
      });

    this.setState({
      listaMenus,
      menuId,
      permissoesModificadas: true,
      permissaoMenuId: -1,
    });
  };

  marcarListaSubMenus = (menuId, checked = false) => {
    let { listaMenus } = this.state;

    let menuPai = -1;
    listaMenus.forEach((menu) => {
      if (menu.DME_ID === menuId) {
        menu.SELECTED = checked;
        menuPai = menu.DME_DME_ID;
      }
    });

    if (menuPai !== -1) {
      listaMenus.forEach((menu) => {
        if (menu.DME_ID === menuPai) {
          menu.SELECTED = true;
        }
      });
    }
    this.setState({ listaMenus, permissoesModificadas: true });
  };

  marcarListaPermissoes = (menuId, checked = false) => {
    let { listaMenus } = this.state;

    let menuPai = -1;
    listaMenus.forEach((menu) => {
      if (menu.DME_ID === menuId) {
        menu.SELECTED = checked;
        menuPai = menu.DME_DME_ID;
      }
    });

    if (menuPai !== -1) {
      listaMenus.forEach((menu) => {
        if (menu.DME_ID === menuPai) {
          menu.SELECTED = true;
        }
      });
    }
    this.setState({ listaMenus, permissoesModificadas: true });
  };

  handleSalvarPermissao = async () => {
    try {
      this.setState({ loading: true });
      const { listaMenus, usuarioSelecionado, empresaAtiva } = this.state;
      if (usuarioSelecionado.USR_ID === undefined) {
        alerta('Antes selecione um usuário!', 2);
        this.setState({ loading: false });
        return;
      }
      let permissao = [];
      listaMenus.forEach(async (menu) => {
        if (menu.SELECTED) {
          var _menu = {};
          _menu.DME_ID = menu.DME_ID;
          permissao.push(_menu);
        }
      });

      const retorno = await api.post(
        '/v1/menus/adicionar/' + empresaAtiva + '/' + usuarioSelecionado.USR_ID,
        permissao
      );
      if (retorno.data.sucess) {
        this.setState({ usuarioSelecionado: {}, permissoesModificadas: false });
        this.handleLimparMenus();
        document.getElementById('usuario').value = -1;
        alerta('Permissões salvas com sucesso!', 1);
      } else {
        alerta(
          'Não foi possível salvar as permissões do usuário. \n' +
            retorno.data.message,
          1
        );
      }
      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
      tratarErros(
        'Não foi possível salvar as permissões do usuario =>' + error,
        2
      );
    }
  };

  render() {
    const {
      loading,
      listaUsuarios,
      permissaoMenuId,
      menuId,
      listaMenus,
      usuarioSelecionado,
    } = this.state;
    return (
      <>
        <Header />
        <ContainerWindowTitle>
          <DirectTituloJanela
            urlVoltar={'/home'}
            titulo={loading ? 'Carregando...' : 'Permissões usuários'}
          />
        </ContainerWindowTitle>
        <Container>
          <div
            style={{
              display: loading ? 'block' : 'none',
              position: 'absolute',
              height: '100vh',
              width: '100vw',
              top: '0px',
              left: '0px',
              backgroundColor: '#00000069',
              zIndex: '1',
            }}
          ></div>

          <Linha>
            <DivDetalhe style={{ width: '100%' }}>
              <label for="usuario">Usuários</label>
              <select
                style={{ display: 'flex' }}
                id="usuario"
                onChange={(e) => {
                  if (this.state.permissoesModificadas) {
                    document.getElementsByClassName('botao-junior')[0].click();
                  } else {
                    this.doChangeUsuario(e.target.value);
                  }
                }}
              >
                <option value="-1">
                  {this.state.loading ? 'Aguarde...' : 'Selecione um usuário'}
                </option>
                {listaUsuarios !== undefined &&
                  listaUsuarios.map((usuario) => (
                    <option key={usuario.USR_ID} value={usuario.USR_ID}>
                      {usuario.USR_NOME}
                    </option>
                  ))}
              </select>
            </DivDetalhe>
            <DivDetalhe>
              <Question
                iconeBotaoPadrao={
                  <span style={{ color: 'white' }}>
                    {' '}
                    <Icon large>arrow_back</Icon>
                  </span>
                }
                classeBotaoPadrao="botao-junior saib-button is-cancel"
                textoBotaoPadrao="Sair"
                titulo="Atenção"
                tituloBotaoSim="Sim"
                classeBotaoSim="saib-button is-primary modal-action modal-close"
                tituloBotaoNao="Não"
                classeBotaoNao="saib-button is-primary modal-action modal-close"
                message={
                  <div>
                    <p>
                      Você NÃO salvou as permissões do usuário{' '}
                      {usuarioSelecionado.USR_NOME}.
                    </p>
                    <br />
                    <p>Confirma a troca de usuário ?</p>
                  </div>
                }
                onNo={() => {
                  document.getElementById('usuario').value =
                    usuarioSelecionado.USR_ID;
                }}
                onYes={() => {
                  this.doChangeUsuario(
                    document.getElementById('usuario').value
                  );
                }}
              />
            </DivDetalhe>
          </Linha>
          <Linha>
            <SubTitulo>Menus</SubTitulo>
          </Linha>
          <Linha
            style={{
              overflowX: 'auto',
              flexDirection: 'row',
            }}
          >
            <DivDetalhe>
              <ul
                style={{
                  width: '288px',
                  overflowY: 'auto',
                  height: '300px',
                  border: '1px solid #ccc',
                  padding: '5px',
                  borderRadius: '10px',
                }}
              >
                {listaMenus !== undefined ? (
                  listaMenus.map((menu) => (
                    <>
                      {menu.DME_DME_ID === 0 && (
                        <>
                          {menu.DME_URL === '#' ? (
                            <>
                              <MenuItem
                                style={{
                                  display: 'flex',
                                  color: '#828282',
                                  fontSize: 'smaller',
                                  padding: '3px',
                                  borderBottom: '1px solid #eee',
                                  marginLeft: '2px',
                                  marginRight: '2px',
                                  backgroundColor: '#f1f1f1',
                                  height: '23px',
                                }}
                                key={menu.DME_ID}
                                onClick={(e) => {
                                  if (
                                    usuarioSelecionado === undefined ||
                                    usuarioSelecionado.USR_ID === undefined
                                  ) {
                                    alerta('Selecione um usuário antes.', 2);
                                    return;
                                  }
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id={'checkbox_' + menu.DME_DESCRICAO}
                                  style={{
                                    marginRight: '5px',
                                  }}
                                  checked={menu.SELECTED}
                                  onClick={(e) => {
                                    menu.SELECTED =
                                      e !== undefined && e.target.checked
                                        ? true
                                        : false;
                                    this.preparaListaSubMenus(
                                      menu.DME_ID,
                                      menu.SELECTED
                                    );
                                  }}
                                />{' '}
                                {menu.DME_DESCRICAO}{' '}
                                {(menu.DME_ICON === '-' ||
                                  menu.DME_URL === '-') && (
                                  <button
                                    style={{
                                      transform: 'rotate(270deg)',
                                    }}
                                    className="saib-button is-cancel"
                                    onClick={() => {
                                      this.setState({ menuId: menu.DME_ID });
                                    }}
                                  >
                                    <Icon>arrow_drop_down</Icon>
                                  </button>
                                )}{' '}
                              </MenuItem>
                            </>
                          ) : (
                            <>
                              <MenuItem
                                key={menu.DME_ID}
                                onClick={(e) => {
                                  if (
                                    usuarioSelecionado === undefined ||
                                    usuarioSelecionado.USR_ID === undefined
                                  ) {
                                    alerta('Selecione um usuário antes.', 2);
                                    return;
                                  }
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id={'checkbox_' + menu.DME_DESCRICAO}
                                  style={{
                                    marginRight: '5px',
                                  }}
                                  checked={menu.SELECTED}
                                  onClick={(e) => {
                                    menu.SELECTED =
                                      e !== undefined && e.target.checked
                                        ? true
                                        : false;
                                    this.preparaListaSubMenus(
                                      menu.DME_ID,
                                      menu.SELECTED
                                    );
                                  }}
                                />
                                {menu.DME_DESCRICAO}{' '}
                                {(menu.DME_ICON === '-' ||
                                  menu.DME_URL === '-') && (
                                  <button
                                    style={{
                                      transform: 'rotate(270deg)',
                                    }}
                                    className="saib-button is-cancel"
                                    onClick={() => {
                                      this.setState({ menuId: menu.DME_ID });
                                    }}
                                  >
                                    <Icon>arrow_drop_down</Icon>
                                  </button>
                                )}{' '}
                              </MenuItem>
                            </>
                          )}
                        </>
                      )}
                    </>
                  ))
                ) : (
                  <></>
                )}
              </ul>
            </DivDetalhe>
            <DivDetalhe>
              <ul
                style={{
                  width: '288px',
                  overflowY: 'auto',
                  height: '300px',
                  border: '1px solid #ccc',
                  padding: '5px',
                  borderRadius: '10px',
                }}
              >
                {listaMenus !== undefined ? (
                  listaMenus.map((menu) => (
                    <>
                      {(menuId !== undefined && (menu.DME_DME_ID === menuId || menu.DME_ICON === menuId.toString())) && (
                        <>
                          {menu.DME_URL === '#' ? (
                            <>
                              <MenuItem
                                style={{
                                  display: 'flex',
                                  color: '#828282',
                                  fontSize: 'smaller',
                                  padding: '3px',
                                  borderBottom: '1px solid #eee',
                                  marginLeft: '2px',
                                  marginRight: '2px',
                                  backgroundColor: '#f1f1f1',
                                  height: '23px',
                                }}
                                key={menu.DME_ID}
                                onClick={(e) => {
                                  if (
                                    usuarioSelecionado === undefined ||
                                    usuarioSelecionado.USR_ID === undefined
                                  ) {
                                    alerta('Selecione um usuário antes.', 2);
                                    return;
                                  }
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id={'checkbox_' + menu.DME_DESCRICAO}
                                  style={{
                                    marginRight: '5px',
                                  }}
                                  checked={menu.SELECTED}
                                  onClick={(e) => {
                                    menu.SELECTED =
                                      e !== undefined && e.target.checked
                                        ? true
                                        : false;
                                    this.marcarListaSubMenus(
                                      menu.DME_ID,
                                      menu.SELECTED
                                    );
                                  }}
                                />{' '}
                                {menu.DME_DESCRICAO}{' '}
                                {(menu.DME_ICON === '-' ||
                                  menu.DME_URL === '-') && (
                                  <button
                                    style={{
                                      transform: 'rotate(270deg)',
                                    }}
                                    className="saib-button is-cancel"
                                    onClick={() => {
                                      this.setState({ menuId: menu.DME_ID });
                                    }}
                                  >
                                    <Icon>arrow_drop_down</Icon>
                                  </button>
                                )}{' '}
                              </MenuItem>
                            </>
                          ) : (
                            <>
                            {menu.DME_PERMISSAO !== 1 && (
                              <MenuItem
                              key={menu.DME_ID}
                              onClick={(e) => {
                                if (
                                  usuarioSelecionado === undefined ||
                                  usuarioSelecionado.USR_ID === undefined
                                ) {
                                  alerta('Selecione um usuário antes.', 2);
                                  return;
                                }
                                this.marcarListaSubMenus(
                                  menu.DME_ID,
                                  e.target.checked
                                );
                              }}
                            >
                              <input
                                type="checkbox"
                                id={'checkbox_' + menu.DME_DESCRICAO}
                                style={{
                                  marginRight: '5px',
                                }}
                                checked={menu.SELECTED}
                              />{' '}
                              {menu.DME_ICON === 'P' && (
                                <button
                                  className="saib-button is-cancel"
                                  onClick={() => {
                                    this.setState({
                                      permissaoMenuId: menu.DME_ID,
                                    });
                                  }}
                                >
                                  <Icon>https</Icon>
                                </button>
                              )}
                              {menu.DME_ICON === '+P' && (
                                <button
                                  className="saib-button is-cancel"
                                  onClick={() => {
                                    this.setState({
                                      permissaoMenuId: menu.DME_ID,
                                    });
                                  }}
                                >
                                  <Icon>https</Icon>
                                </button>
                              )}
                              {menu.DME_DESCRICAO}{' '}
                            </MenuItem>

                            )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  ))
                ) : (
                  <></>
                )}
              </ul>
            </DivDetalhe>
            <DivDetalhe>
              <ul
                style={{
                  width: '288px',
                  overflowY: 'auto',
                  height: '300px',
                  border: '1px solid #ccc',
                  padding: '5px',
                  borderRadius: '10px',
                }}
              >
                {listaMenus !== undefined ? (
                  listaMenus.map((menu) => (
                    <>
                      {menu.DME_DME_ID === permissaoMenuId && (
                        <>
                          {menu.DME_PERMISSAO === 1 && (
                            <>
                              <MenuItem
                                key={menu.DME_ID}
                                onClick={(e) => {
                                  if (
                                    usuarioSelecionado === undefined ||
                                    usuarioSelecionado.USR_ID === undefined
                                  ) {
                                    alerta('Selecione um usuário antes.', 2);
                                    return;
                                  }
                                  this.marcarListaSubMenus(
                                    menu.DME_ID,
                                    e.target.checked
                                  );
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id={'checkbox_' + menu.DME_DESCRICAO}
                                  style={{
                                    marginRight: '5px',
                                  }}
                                  checked={menu.SELECTED}
                                />{' '}
                                {menu.DME_DESCRICAO}{' '}
                              </MenuItem>
                            </>
                          )}
                        </>
                      )}
                    </>
                  ))
                ) : (
                  <></>
                )}
              </ul>
            </DivDetalhe>
          </Linha>
          <LinhaRodape>
            <DivRodape>
              <button
                className="saib-button is-primary "
                onClick={() => {
                  this.handleSalvarPermissao();
                }}
              >
                <Icon>save</Icon> Salvar
              </button>
              <button
                className="saib-button is-primary "
                onClick={() => {
                  window.location.href = '/home'; // this.props.history.goBack();
                }}
              >
                <Icon>arrow_back</Icon> Cancelar
              </button>
            </DivRodape>
          </LinhaRodape>
        </Container>
      </>
    );
  }
}
